export const pathsWithSemanticFooter = ['/', '/portal'];
